export const Languages = [
    { displayText: 'English', code: 'en' },
    { displayText: 'Español', code: 'es' },
    { displayText: ' العربية', code: 'ar' },
    { displayText: 'Deutsch', code: 'de' },
    { displayText: 'français', code: 'fr' }
];

export const DefaultLanguageCode = 'en';

export const DefaultLanguageDisplayName = 'language.en';

export const AvailableLanguages = ['en', 'es', 'ar', 'de', 'fr'];

export type LanguageCode = 'en' | 'es' | 'ar' | 'de' | 'fr';
